import {
    ModelSetTransformer,
    ModelTransformer,
} from '../../../../common/common.model';

export interface ExtLobItem {
    tenantId: number;
    lobId: number;
    lobDefaultInitials: string;
    lobDefaultShortName: string;
    lobDefaultName: string;
    clientTranslationTextId: number;
    enabled: boolean;
    createdByUserId: number;
    createdOn: string;
    lastUpdatedByUserId: number;
    lastUpdatedOn: string;
    languageID: number;
}

export interface LobItem {
    id: number;
    initials: string;
    shortName: string;
    name: string;
}

class LobItemModelTransformer implements ModelTransformer<LobItem, ExtLobItem> {
    transform(model: ExtLobItem): LobItem {
        return {
            id: model.lobId,
            initials: model.lobDefaultInitials,
            shortName: model.lobDefaultShortName,
            name: model.lobDefaultName,
        };
    }
}

export class LobItemModelSetTransformer extends ModelSetTransformer<
    LobItem,
    ExtLobItem
> {
    protected newTransformer(): ModelTransformer<LobItem, ExtLobItem> {
        return new LobItemModelTransformer();
    }
}
